import Vue from "vue";
import Router from "vue-router";
import LoginComponent from "./views/login.vue";
import UsersComponent from "./views/users.vue";
import WeezysComponent from "./views/weezys.vue";
import CampaignsComponent from "./views/campaigns.vue";
import ThemesComponent from "./views/themes.vue";
import SalesComponent from "./views/sales.vue";
import GoalsComponent from "./views/goals.vue";
import ConfigsComponent from "./views/configs.vue";
import DashboardComponent from "./views/dashboard.vue";
import GameScoresComponent from "./views/gamescores.vue";
import WeezyPicturesComponent from "./views/weezypictures.vue";
import ChallengesComponent from "./views/challenges.vue";
import CustomizationsComponent from "./views/customizations.vue";
import PublicPicturesComponent from "./views/public/public_pictures.vue";
import PublicGameScoresComponent from "./views/public/public_gamescores.vue";
import PublicChallengesComponent from "./views/public/public_challenges.vue";

Vue.use(Router);

export default new Router({
  // <<<<<<< HEAD
  //     // mode: "history",
  // =======
  mode: "history",
  // >>>>>>> wordpress_plugin
  routes: [
    {
      path: "/",
      redirect: {
        name: "dashboard"
      }
    },
    {
      path: "/login",
      name: "login",
      component: LoginComponent
    },
    {
      path: "/users",
      name: "users",
      component: UsersComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/weezys",
      name: "weezys",
      component: WeezysComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/campaigns",
      name: "campaigns",
      component: CampaignsComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/themes",
      name: "themes",
      component: ThemesComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/sales",
      name: "sales",
      component: SalesComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/goals",
      name: "goals",
      component: GoalsComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/config",
      name: "config",
      component: ConfigsComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: DashboardComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/gamescores",
      name: "gamescores",
      component: GameScoresComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/weezypictures",
      name: "weezypictures",
      component: WeezyPicturesComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/publicpictures/2b1ks5Fr0SHCWT1RuzDjNnIL0KLgpxO5jy7OC6",
      name: "publicpictures",
      component: PublicPicturesComponent
    },
    {
      path: "/publicgamescores/b0t6GtpFZjG8woqUOOJWge7gpdzbBeYD8gW7pe",
      name: "publicgamescores",
      component: PublicGameScoresComponent
    },
    {
      path: "/publicchallenges/1TwWwE3Pt2dglvxTRuGqqRKl5M0NlUWZGvnepe",
      name: "publicchallenges",
      component: PublicChallengesComponent
    },
    {
      path: "/challenges",
      name: "challenges",
      component: ChallengesComponent,
      roles: ["supervisor", "admin"]
    },
    {
      path: "/customizations",
      name: "customizations",
      component: CustomizationsComponent,
      roles: ["supervisor", "admin"]
    }
  ]
});
